module.exports = __webpack_public_path__ + "img/adobe-creative-cloud.afdca007.png";